import React, { useState, useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import Login from '../../pages/Login/';
import Account from '../../pages/User/account';
import Campaigns from '../../pages/MyPages/campaigns';
import CartContextProvider from '../../components/Context/cart/CartContext';
import Checkout from '../../pages/Shop/checkout';
import Complaint from '../../pages/Complaints/complaint';
import Complaints from '../../pages/Complaints/complaints';
import ComplaintNew from '../../pages/Complaints/complaint-new';
import ComplaintsHistory from '../../pages/Complaints/complaints-history';
import CPQ from '../../pages/CPQ/';
import Finance from '../../pages/Finance/';
import HeaderDefault from '../../components/Header/';
import HeaderShop from '../../components/Header/shop';
import Home from '../../pages/Home/';
import Invoices from '../../pages/Finance/invoices';
import Download from 'scripts/pages/Media/download';
import NewConstruction from 'scripts/pages/Media/new-construction';
import Media from '../../pages/Media/';
import MediaCampaign from '../../pages/Media/campaign';
import MediaDop from '../../pages/Media/declaration-of-performance';
import MediaHighResolution from '../../pages/Media/high-resolution';
import MediaManuals from '../../pages/Media/manuals';
import MediaSigns from '../../pages/Media/signs';
import MediaVideo from '../../pages/Media/video';
import MyPagesProductsInShowroom from '../../pages/MyPages/products-in-showroom';
import MyPagesAddProducts from '../../pages/MyPages/add-products';
// import NavigationDownload from '../../components/Navigation/download';
import Navigation from '../../components/Navigation';
import News from '../../pages/MyPages/news';
import Article from '../../components/News/NewsArticle';
import NotFound from '../../pages/NotFound/';
import Orders from '../../pages/Orders/';
import OrderAdd from '../../pages/Orders/order-add';
import OrderHistory from '../../pages/Orders/order-history';
import Product from '../../pages/Product/';
import Shop from '../../pages/Shop/';
import ShoppingCart from '../../components/Cart/shopping-cart';
import Contact from '../../pages/Contact';
import NewsOverlay from '../News/NewsOverlay';
import UserAdmin from '../../pages/User/admin';
// import TagManager from 'react-gtm-module';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { InteractionStatus } from '@azure/msal-browser';
import {
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useAccount,
    useIsAuthenticated
} from '@azure/msal-react';
import { convertToLocale, convertMarketToCurrency } from '../Utils/market';
import useAxios from 'scripts/hooks/useAxios';
import { useGlobalState } from 'scripts/contexts/GlobalStateContext';

const App = () => {
    const { accounts, inProgress, instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const accountInfo = useAccount(accounts[0] || {});
    const { i18n } = useTranslation();
    const [isAdmin, setIsAdmin] = useState(false);
    const [locale, setLocale] = useState("");
    const [customLocale, setCustomLocale] = useState("");
    const [market, setMarket] = useState("")
    const { callApi } = useAxios();
    const { globalState } = useGlobalState();
    const [currency, setCurrency] = useState("");

    // const tagManagerArgs = {
    //     gtmId: 'GTM-KG7PW8K',
    // };
    //
    // TagManager.initialize(tagManagerArgs);

    useEffect(() => {
        i18n.changeLanguage(globalState.language || 'en');
    }, [i18n, globalState.language]);

    useEffect(() => {
        if (isAuthenticated && inProgress === InteractionStatus.None && globalState?.activeUserCompany !== null) {
            const custMarket = globalState?.activeUserCompany?.market?.toLowerCase() ?? 'se';
            const isAdminUser = globalState?.activeUserCompany?.roles?.toLowerCase().includes('portal admin') ?? false;

            setMarket(custMarket);
            setLocale(convertToLocale(custMarket));
            setCurrency(convertMarketToCurrency(custMarket))

            let customerRole = accountInfo?.customertypecode;
            if (customerRole === "899310003") { setCustomLocale(convertToLocale(customerRole)); }

            setIsAdmin(isAdminUser)
        }
    }, [accountInfo, inProgress, i18n, isAuthenticated, instance, callApi, globalState?.activeUserCompany]);

    let location = useLocation();

    let baseName =
        location.pathname === '/' ? 'home' : location.pathname.split('/')[1];


    let Header = () => {
        switch (baseName) {
            case 'cpq':
                return '';
            default:
                return <HeaderDefault />;
        }
    };

    let hideOffCanvas = () => {
        document.documentElement.classList.remove('has-visible-mobile-menu');
        document.documentElement.classList.remove('has-visible-shopping-cart');
    };

    return (
        <>
            <AuthenticatedTemplate>
                <CartContextProvider>
                    {baseName !== 'cpq' ? (
                        <div
                            className={`page-content page-content-${baseName}`}
                        >
                            <NewsOverlay market={locale} />
                            <div className="main-container">
                                {Header(baseName)}
                                <Switch>
                                    <Route exact path="/">
                                        <Redirect to="/home" />
                                    </Route>
                                    <Route exact path="/download">
                                        <Redirect to="/media-signs" />
                                    </Route>
                                    <Route
                                        path="/account"
                                        component={Account}
                                    />
                                    <Route
                                        path="/campaigns"
                                        component={Campaigns}
                                    />
                                    <Route
                                        path="/checkout"
                                        component={Checkout}
                                    />
                                    <Route
                                        path="/complaints"
                                        component={Complaints}
                                    />
                                    <Route
                                        path="/complaints-history"
                                        component={ComplaintsHistory}
                                    />
                                    <Route
                                        path="/complaint/:incidentId?"
                                        component={Complaint}
                                    />
                                    <Route
                                        path="/complaint-new/:searchId?"
                                        component={ComplaintNew}
                                    />
                                    <Route
                                        path="/contact"
                                        render={(props) => <Contact {...props} market={customLocale ? customLocale : locale} />}
                                    />
                                    <Route
                                        path="/finance"
                                        component={Finance}
                                    />
                                    <Route path="/home" component={Home} />
                                    {isAdmin &&
                                        <Route
                                            path="/invoices"
                                            component={Invoices}
                                        />
                                    }
                                    <Route
                                        path="/media"
                                        render={(props) => <Media {...props} market={customLocale ? customLocale : locale} />}
                                    />
                                    <Route
                                        path="/media-campaign"
                                        render={(props) => <MediaCampaign {...props} market={customLocale ? customLocale : locale} />}
                                    />
                                    <Route
                                        path="/media-dop"
                                        render={(props) => <MediaDop {...props} market={locale} />}
                                    />
                                    <Route
                                        path="/media-high-resolution"
                                        render={(props) => <MediaHighResolution {...props} market={'image-global'} />}
                                    />
                                    <Route
                                        path="/media-manuals"
                                        render={(props) => <MediaManuals {...props} market={locale} />}
                                    />
                                    <Route
                                        path="/media-signs"
                                        render={(props) => <MediaSigns {...props} market={customLocale ? customLocale : "global"} />}
                                    />
                                    <Route
                                        path="/media-video"
                                        render={(props) => <MediaVideo {...props} market={locale} />}
                                    />
                                    <Route
                                        path="/news/:id"
                                        component={Article}
                                    />
                                    <Route
                                        path="/my-pages/products-in-showroom"
                                        component={MyPagesProductsInShowroom}
                                    />
                                    <Route
                                        path="/my-pages/add-products"
                                        component={MyPagesAddProducts}
                                    />
                                    <Route
                                        exact
                                        path="/news"
                                        render={(props) => <News {...props} market={locale} />}
                                    />
                                    <Route
                                        path="/NotFound"
                                        component={NotFound}
                                    />
                                    <Route
                                        path="/order-add"
                                        component={OrderAdd}
                                    />
                                    <Route path="/orders" component={Orders} />
                                    <Route
                                        path="/order-history"
                                        component={OrderHistory}
                                    />
                                    <Route
                                        path="/shop/category/:categoryId"
                                        render={(props) => <Shop {...props} locale={locale} />}
                                    />
                                    <Route
                                        path="/shop/product/:productId"
                                        render={(props) => <Product {...props} locale={locale} currency={currency} />}
                                    />
                                    <Route
                                        path="/user-admin"
                                        component={UserAdmin}
                                    />
                                    <Route exact path="/download">
                                        <Redirect to="/media" />
                                    </Route>
                                    <Route path="*" component={NotFound} />
                                </Switch>
                            </div>
                            <div
                                className="overlay"
                                onClick={hideOffCanvas}
                            ></div>
                            <Navigation />
                            <ShoppingCart />
                        </div>
                    ) : (
                        <>
                            <Route
                                path="/cpq"
                                render={(props) => <CPQ {...props} />}
                            />
                        </>
                    )}
                </CartContextProvider>
            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>

                <Route exact path="/" component={Login} />

                <Route
                    path="/download"
                    render={(props) => <Download {...props} baseName={baseName} unauthenticated={true} market={'sv-SE'} />}
                />

                <Route
                    path="/new-construction"
                    render={(props) => <NewConstruction {...props} baseName={baseName} newConstruction={true} market={'sv-SE'} />}
                />
                <Route exact path="/*" component={Login} />

            </UnauthenticatedTemplate>
        </>
    );
};

export default App;
